var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0303 0.970646C16.3232 1.26354 16.3232 1.73841 16.0303 2.03131L9.47076 8.59083C9.17787 8.88372 8.70299 8.88372 8.4101 8.59083C8.11721 8.29794 8.11721 7.82306 8.4101 7.53017L14.9696 0.970646C15.2625 0.677753 15.7374 0.677753 16.0303 0.970646Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91675 1.50098C9.91675 1.08676 10.2525 0.750977 10.6667 0.750977H15.5001C15.9143 0.750977 16.2501 1.08676 16.2501 1.50098V6.33431C16.2501 6.74852 15.9143 7.08431 15.5001 7.08431C15.0859 7.08431 14.7501 6.74852 14.7501 6.33431V2.25098H10.6667C10.2525 2.25098 9.91675 1.91519 9.91675 1.50098Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.46967 4.7685C0.610322 4.62785 0.801088 4.54883 1 4.54883H4.79762C5.21183 4.54883 5.54762 4.88461 5.54762 5.29883C5.54762 5.71304 5.21183 6.04883 4.79762 6.04883H1.75L1.75 15.2512L10.9524 15.2512V12.2036C10.9524 11.7894 11.2882 11.4536 11.7024 11.4536C12.1166 11.4536 12.4524 11.7894 12.4524 12.2036V16.0012C12.4524 16.4154 12.1166 16.7512 11.7024 16.7512L1 16.7512C0.801088 16.7512 0.610323 16.6722 0.46967 16.5315C0.329018 16.3909 0.25 16.2001 0.25 16.0012L0.25 5.29883C0.25 5.09992 0.329018 4.90915 0.46967 4.7685Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkout);
export default __webpack_public_path__ + "static/media/linkout.c8e5dc6b205f1063238d3e01ff32120f.svg";
export { ForwardRef as ReactComponent };